import { createSlice } from "@reduxjs/toolkit";

const parseErrorMessage = (error) => {
    return (
        (error.response &&
            error.response.data &&
            error.response.data.message) ||
        error.message ||
        error.toString()
    );
};

export const AlertSlice = createSlice({
    name: "alert",
    initialState: {
        open: false,
        id: 0,
        severity: undefined,
        message: undefined,
        lastHash: undefined,
        lastShownAt: 0,
    },
    reducers: {
        hideAlert: (state) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.open = false;
            state.severity = undefined;
            state.message = undefined;
        },
        showAlert: (state, action) => {
            const severity = action.payload.severity || "info";
            const message = parseErrorMessage(action.payload.message);
            const hash = `${severity}::${message}`;
            const now = Date.now();

            // Ignore burst duplicates from very fast repeated clicks/actions.
            if (
                state.lastHash === hash &&
                now - state.lastShownAt < 1000
            ) {
                return;
            }

            state.id += 1;
            state.severity = severity;
            state.message = message;
            state.open = true;
            state.lastHash = hash;
            state.lastShownAt = now;
        },
    },
});

export const { hideAlert, showAlert } = AlertSlice.actions;

export const autoHide = (duration) => (dispatch) => {
    setTimeout(() => {
        dispatch(hideAlert());
    }, duration);
};

export const selectOpen = (state) => state.alert.open;
export const selectAlertId = (state) => state.alert.id;
export const selectMessage = (state) => state.alert.message;
export const selectSeverity = (state) => state.alert.severity;

export default AlertSlice.reducer;
